import React from "react";
import "./sectionTwo.css";
import SectionSpacer from "../SectionSpacer/SectionSpacer";
import { FaCheckCircle } from "react-icons/fa";

const SectionTwo = () => {
  const sections = [
    {
      title: "Unleash Engagement Superpower",
      items: [
        "Personalize DMs At Scale",
        "Sell In Story, Reach Your Glory",
        "Drive Conversations In Comments",
      ],
    },
    {
      title: "Turbocharge Your Influence",
      items: [
        "Promote Affiliate Links",
        "Optimize Campaigns",
        "Track Your Impact",
      ],
    },
  ];

  return (
    <div className="sectionTwo-style">
      <p className="custom-paragraph-section-two App-logo-font">Why RAWGR?</p>
      <div className="sectionTwoContainer">
        {sections.map((section, index) => (
          <div key={index} className="sectionTwoInfo">
            <p className="sectionTwoInfoTop">{section.title}</p>
            <ul className="sectionTwoInfoList">
              {section.items.map((item, idx) => (
                <li key={idx} className="sectionTwoInfoBottom">
                  <FaCheckCircle className="sectionTwoInfoBottomTick" />

                  <span className="highlight">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionTwo;
